import { UnifiedBankAccount } from '../unified-bank-account';

export class AllianceBankAccount
{
    accountNumber: string;
    accountType: number;
    dateOpened: string;
    dateClosed: string;
    unifiedBankAccount: UnifiedBankAccount;

    constructor(ref) {
        this.accountNumber = ref.accountNumber;
        this.accountType = ref.accountType;
        this.dateOpened = ref.dateOpened;
        this.dateClosed = ref.dateClosed;
        this.unifiedBankAccount = ref.unifiedBankAccount ? new UnifiedBankAccount(ref.unifiedBankAccount) : null;
    }
}
